import React, { useEffect } from 'react';

import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './SidebarNavigation.module.scss';
import { SidebarNavLink } from '../components/SidebarNavLink/SidebarNavLink';
import { SidebarSolutionSection } from './SidebarSolutionSection/SidebarSolutionSection';
import { SIDEBAR_ITEM_TYPE } from '../../../constants/system/headerSettings';
import { MainNavItem } from '../../../interfaces/system/SidebarNavConfig';
import { solutionsStore } from '../../../stores/solutionsStore';
import { unreadScansCountStore } from '../../../stores/unreadScansCountStore';
import { goToSolutionHome } from '../../../utils/angularUtils';

type SidebarNavigationProps = {
  items: MainNavItem[];
};

const SidebarNavigation = observer(({ items }: SidebarNavigationProps) => {
  const { activeSolution } = solutionsStore;

  useEffect(() => {
    unreadScansCountStore.getUnreadScansCount(activeSolution);
  }, [activeSolution]);

  return (
    <nav className={classes.navBox}>
      {items.map((item) => {
        const isExpanded =
          item.type === SIDEBAR_ITEM_TYPE.SOLUTION && activeSolution === item.subType;

        return (
          <div
            key={item.label}
            className={classNames(classes.sectionBox, {
              [classes.expanded]: isExpanded,
            })}
          >
            {item.type === SIDEBAR_ITEM_TYPE.LINK && <SidebarNavLink item={item} />}
            {item.type === SIDEBAR_ITEM_TYPE.SOLUTION && (
              <SidebarSolutionSection
                item={item}
                isExpanded={isExpanded}
                onToggle={() => goToSolutionHome(item.subType)}
              />
            )}
          </div>
        );
      })}
    </nav>
  );
});

export { SidebarNavigation };
